// Náttúrufræðistofnun's automatic pollen monitors (Swisens Poleno Mars).
// Counts are published hourly in season, but only inside an embedded Power BI
// report, so there is no data feed to read yet; the map shows the sites and
// links to the live graphs and the forecast.
const NATT =
  "https://www.natt.is/is/rannsoknir/rannsokna-og-voktunarverkefni/frjomaelingar";

export const POLLEN_LINKS = {
  live: `${NATT}/sjalfvirkir-frjokornamaelar`,
  forecast: `${NATT}/frjokornaspa`,
};

export const POLLEN_SITES = [
  {
    id: "pollen-gardabaer",
    name: "Garðabær",
    place: "Náttúrufræðistofnun, Urriðaholtsstræti",
    since: "May 2024",
    lat: 64.0743,
    lon: -21.9063,
  },
  {
    id: "pollen-akureyri",
    name: "Akureyri",
    place: "Borgir, Norðurslóð",
    since: "2022",
    lat: 65.6848,
    lon: -18.1197,
  },
];

// Pollen is measured from April to the end of September
export const inPollenSeason = (date = new Date()) => {
  const month = date.getUTCMonth() + 1;
  return month >= 4 && month <= 9;
};
